import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources for 10 languages
const resources = {
  en: {
    translation: {
      nav: {
        work: "Work",
        about: "About",
        services: "Services",
        contact: "Contact",
        blog: "Blog",
        getInTouch: "Get in touch"
      },
      hero: {
        title: "Berlin's",
        titleHighlight: "AI-driven digital marketer",
        titleEnd: "turning paid campaigns into predictable growth",
        subtitle: "Full-funnel performance marketing across Meta, TikTok, Instagram, SEO, and email — powered by AI tools that scale results faster",
        cta1: "View case studies",
        cta2: "Get a growth audit"
      },
      footer: {
        copyright: "Aryan Shivhare. Berlin-based digital marketer."
      }
    }
  },
  de: {
    translation: {
      nav: {
        work: "Arbeiten",
        about: "Über mich",
        services: "Dienstleistungen",
        contact: "Kontakt",
        blog: "Blog",
        getInTouch: "Kontakt aufnehmen"
      },
      hero: {
        title: "Berlins",
        titleHighlight: "KI-gestützter Digital Marketer",
        titleEnd: "verwandelt bezahlte Kampagnen in vorhersehbares Wachstum",
        subtitle: "Full-Funnel-Performance-Marketing über Meta, TikTok, Instagram, SEO und E-Mail – angetrieben von KI-Tools, die Ergebnisse schneller skalieren",
        cta1: "Fallstudien ansehen",
        cta2: "Wachstumsaudit erhalten"
      },
      footer: {
        copyright: "Aryan Shivhare. Berliner Digital Marketer."
      }
    }
  },
  es: {
    translation: {
      nav: {
        work: "Trabajo",
        services: "Servicios",
        contact: "Contacto",
        blog: "Blog",
        getInTouch: "Contactar"
      },
      hero: {
        title: "El",
        titleHighlight: "especialista en marketing digital impulsado por IA",
        titleEnd: "de Berlín que convierte campañas pagadas en crecimiento predecible",
        subtitle: "Marketing de rendimiento full-funnel en Meta, TikTok, Instagram, SEO y email — impulsado por herramientas de IA que escalan resultados más rápido",
        cta1: "Ver casos de estudio",
        cta2: "Obtener auditoría de crecimiento"
      },
      footer: {
        copyright: "Aryan Shivhare. Especialista en marketing digital en Berlín."
      }
    }
  },
  fr: {
    translation: {
      nav: {
        work: "Travaux",
        about: "À propos",
        services: "Services",
        contact: "Contact",
        blog: "Blog",
        getInTouch: "Contactez-moi"
      },
      hero: {
        title: "Le",
        titleHighlight: "spécialiste du marketing digital basé sur l'IA",
        titleEnd: "de Berlin qui transforme les campagnes payantes en croissance prévisible",
        subtitle: "Marketing de performance full-funnel sur Meta, TikTok, Instagram, SEO et email — propulsé par des outils IA qui accélèrent les résultats",
        cta1: "Voir les études de cas",
        cta2: "Obtenir un audit de croissance"
      },
      footer: {
        copyright: "Aryan Shivhare. Spécialiste en marketing digital basé à Berlin."
      }
    }
  },
  it: {
    translation: {
      nav: {
        work: "Lavoro",
        about: "Chi sono",
        services: "Servizi",
        contact: "Contatto",
        blog: "Blog",
        getInTouch: "Contattami"
      },
      hero: {
        title: "Il",
        titleHighlight: "marketer digitale guidato dall'IA",
        titleEnd: "di Berlino che trasforma le campagne a pagamento in crescita prevedibile",
        subtitle: "Marketing delle prestazioni full-funnel su Meta, TikTok, Instagram, SEO ed email — alimentato da strumenti AI che scalano i risultati più velocemente",
        cta1: "Visualizza casi di studio",
        cta2: "Ottieni un audit di crescita"
      },
      footer: {
        copyright: "Aryan Shivhare. Marketer digitale con sede a Berlino."
      }
    }
  },
  pt: {
    translation: {
      nav: {
        work: "Trabalho",
        services: "Serviços",
        contact: "Contato",
        blog: "Blog",
        getInTouch: "Entre em contato"
      },
      hero: {
        title: "O",
        titleHighlight: "profissional de marketing digital impulsionado por IA",
        titleEnd: "de Berlim que transforma campanhas pagas em crescimento previsível",
        subtitle: "Marketing de desempenho full-funnel no Meta, TikTok, Instagram, SEO e email — impulsionado por ferramentas de IA que escalam resultados mais rápido",
        cta1: "Ver estudos de caso",
        cta2: "Obter auditoria de crescimento"
      },
      footer: {
        copyright: "Aryan Shivhare. Profissional de marketing digital baseado em Berlim."
      }
    }
  },
  hi: {
    translation: {
      nav: {
        work: "काम",
        about: "परिचय",
        services: "सेवाएं",
        contact: "संपर्क",
        blog: "ब्लॉग",
        getInTouch: "संपर्क करें"
      },
      hero: {
        title: "बर्लिन का",
        titleHighlight: "AI-संचालित डिजिटल मार्केटर",
        titleEnd: "पेड कैंपेन को अनुमानित विकास में बदलता है",
        subtitle: "Meta, TikTok, Instagram, SEO और ईमेल पर फुल-फ़नल प्रदर्शन मार्केटिंग — AI उपकरणों द्वारा संचालित जो परिणामों को तेज़ी से स्केल करते हैं",
        cta1: "केस स्टडीज़ देखें",
        cta2: "विकास ऑडिट प्राप्त करें"
      },
      footer: {
        copyright: "अर्यन शिवहरे। बर्लिन स्थित डिजिटल मार्केटर।"
      }
    }
  },
  ar: {
    translation: {
      nav: {
        work: "العمل",
        about: "نبذة عني",
        services: "الخدمات",
        contact: "اتصل",
        blog: "المدونة",
        getInTouch: "تواصل معنا"
      },
      hero: {
        title: "",
        titleHighlight: "مسوق رقمي مدعوم بالذكاء الاصطناعي في برلين",
        titleEnd: "يحول الحملات المدفوعة إلى نمو يمكن التنبؤ به",
        subtitle: "تسويق الأداء الكامل عبر Meta و TikTok و Instagram و SEO والبريد الإلكتروني — مدعوم بأدوات الذكاء الاصطناعي التي تحقق نتائج أسرع",
        cta1: "عرض دراسات الحالة",
        cta2: "احصل على تدقيق النمو"
      },
      footer: {
        copyright: "أريان شيفهار. مسوق رقمي مقره برلين."
      }
    }
  },
  zh: {
    translation: {
      nav: {
        work: "作品",
        about: "关于",
        services: "服务",
        contact: "联系",
        blog: "博客",
        getInTouch: "联系我们"
      },
      hero: {
        title: "柏林的",
        titleHighlight: "AI驱动的数字营销专家",
        titleEnd: "将付费广告转化为可预测的增长",
        subtitle: "跨Meta、TikTok、Instagram、SEO和电子邮件的全漏斗绩效营销 — 由AI工具驱动，更快地扩展结果",
        cta1: "查看案例研究",
        cta2: "获取增长审计"
      },
      footer: {
        copyright: "Aryan Shivhare。柏林数字营销专家。"
      }
    }
  },
  ja: {
    translation: {
      nav: {
        work: "実績",
        about: "プロフィール",
        services: "サービス",
        contact: "お問い合わせ",
        blog: "ブログ",
        getInTouch: "お問い合わせ"
      },
      hero: {
        title: "ベルリンの",
        titleHighlight: "AI駆動のデジタルマーケター",
        titleEnd: "が有料キャンペーンを予測可能な成長に変える",
        subtitle: "Meta、TikTok、Instagram、SEO、メールにわたるフルファネルパフォーマンスマーケティング — より速く結果をスケールするAIツールによって強化",
        cta1: "ケーススタディを見る",
        cta2: "成長監査を受ける"
      },
      footer: {
        copyright: "Aryan Shivhare。ベルリンを拠点とするデジタルマーケター。"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
